/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./batch-button.vue?vue&type=template&id=5a814c9e&scoped=true&"
import script from "./batch-button.vue?vue&type=script&lang=js&"
export * from "./batch-button.vue?vue&type=script&lang=js&"
import style0 from "./batch-button.vue?vue&type=style&index=0&id=5a814c9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a814c9e",
  null
  
)

export default component.exports